/**
 * Author: SCS (Santosh Chandra Shekhar)
 * ***scs***
 */

import React, { useContext } from "react";
import "./Works.css";
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Amazon from "../../img/amazon.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import {Link} from 'react-scroll'
const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // Company URLs
  const companyLinks = {
    upwork: "https://www.upwork.com",
    fiverr: "https://www.fiverr.com",
    amazon: "https://www.amazon.com",
    shopify: "https://www.shopify.com",
    facebook: "https://www.facebook.com"
  };

  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>
          Brands & Clients
          </span>
          <span>All Covered</span>
          <spane>
          Our website design services include creating attractive, easy to use,<br/> and responsive websites that are optimized for search engines.<br/>We can also help you create custom logos, graphics, and branding <br/>for your website.
            <br />
            Our maintenance services ensure your website is up to date, secure,<br/> and running smoothly. We offer bug fixes, security updates, <br/>and feature enhancements.
          </spane>
          <Link className="mob_pos" to="contact" smooth={true} spy={true}>
            <button className="button s-button">Hire Me</button>
          </Link>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div
          animate={{ rotate: -360 }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "linear",
            repeatDelay: 2
          }}
          className="w-mainCircle"
        >
          <a href={companyLinks.upwork} target="_blank" rel="noopener noreferrer" className="w-secCircle">
            <img src={Upwork} alt="Upwork" />
          </a>
          <a href={companyLinks.fiverr} target="_blank" rel="noopener noreferrer" className="w-secCircle">
            <img src={Fiverr} alt="Fiverr" />
          </a>
          <a href={companyLinks.amazon} target="_blank" rel="noopener noreferrer" className="w-secCircle">
            <img src={Amazon} alt="Amazon" />
          </a>{" "}
          <a href={companyLinks.shopify} target="_blank" rel="noopener noreferrer" className="w-secCircle">
            <img src={Shopify} alt="Shopify" />
          </a>
          <a href={companyLinks.facebook} target="_blank" rel="noopener noreferrer" className="w-secCircle">
            <img src={Facebook} alt="Facebook" />
          </a>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
